module.exports = __webpack_public_path__ + "static/media/solutions-page-heroimage-freelancer-businessowners.8937a4e2.webp";